export const CCY_SYMBOLS = { AUD: "A$", USD: "US$", GBP: "£", EUR: "€" };

export const REGION_LABELS = { AU: "Australia", US: "United States", UK: "United Kingdom", ROW: "Rest of World" };
export const MARKET_LABELS = {
  DIRECT: "Healing House Direct (website)",
  AU: "IngramSpark · Australia",
  US: "IngramSpark · United States",
  UK: "IngramSpark · United Kingdom",
  ROW: "IngramSpark · Rest of World",
};

export const FORMAT_LABELS = { paperback: "Paperback", hardcover: "Hardcover", ebook: "eBook" };

export function fmtMoney(amount, currency = "AUD") {
  const sym = CCY_SYMBOLS[currency] || (currency + " ");
  if (amount == null || isNaN(amount)) return `${sym}0.00`;
  return `${sym}${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtMoneyByCcy(map) {
  if (!map || Object.keys(map).length === 0) return fmtMoney(0, "AUD");
  return Object.entries(map)
    .map(([ccy, amt]) => fmtMoney(amt, ccy))
    .join("  ·  ");
}

export function fmtNumber(n) {
  return (n ?? 0).toLocaleString();
}

export function monthLabel(ym) {
  if (!ym) return "";
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString(undefined, { month: "short", year: "2-digit" });
}

export function fmtDateShort(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch (_e) {
    return iso;
  }
}

export function fmtDateRange(startIso, endIso) {
  return `${fmtDateShort(startIso)} → ${fmtDateShort(endIso)}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });
  } catch (_e) {
    return iso;
  }
}

export function cycleShort(cycle) {
  // "Q3-2025" → "Q3 2025"  ·  legacy "H1-2025" → "First half 2025"
  if (!cycle) return "";
  const [head, year] = cycle.split("-");
  if (head?.startsWith("Q")) return `${head} ${year}`;
  if (head === "H1") return `First half ${year}`;
  if (head === "H2") return `Second half ${year}`;
  return cycle;
}

export function cycleLabel(cycle, startIso, endIso) {
  // "Q3-2025" → "Q3 2025 · 1 Jul → 30 Sep 2025"
  if (!cycle) return "";
  return `${cycleShort(cycle)} · ${fmtDateRange(startIso, endIso)}`;
}
